// extracted by mini-css-extract-plugin
module.exports = {"info":"UpdateRegulations_info__1iOVc","alert":"UpdateRegulations_alert__lELrs","pills":"UpdateRegulations_pills__1cCYi","preview":"UpdateRegulations_preview__1CrA9"};